import React, {useState} from "react";
import moment from 'moment';
import Avatar from 'react-avatar';

import WithUserData from "./WithUserData";
import {Link} from "react-router-dom";
import EditProfile from "../../assets/images/edit_profile.svg";
import MemberServices from "../../assets/images/member_services.svg";
import Preferences from "../../assets/images/preferences.svg";
import settings from "../../assets/images/settings.svg";
import Modal from "../BrandSignup/Modal"

const Account = () => {
    const membershipNames = {
        ICON_APP_MEMBERSHIP: "Icon .app",
        ICON_STUDIO_MEMBERSHIP: "Icon .studio",
        BRAND_APP_MEMBERSHIP: "Brand .app",
        BRAND_STUDIO_MEMBERSHIP: "Brand .studio",
    };
    const [showFeatureComingSoonPopup, setShowFeatureComingSoonPopup] = useState(false)
    return (
        <WithUserData>
            {({ user }) => {
                const buttonClassName = "cursor-pointer w-full h-16 border border-black text-gray-900 text-lg rounded-lg flex items-center hover:bg-gray-200 mt-0 sm:mt-3"
                const iconClassName = "h-10";
                return (
                    <div className='w-full h-full flex flex-col justify-between sm:justify-start'>
                        <div className="w-full mt-4 px-2 text-gray-900 text-md">
                            <div className="w-full h-42 pl-2 flex items-center justify-between">
                                <Avatar src="" size="160" color='#899499' round={true} name={`${user.firstName} ${user.lastName}`} />
                                <div className="h-18 flex justify-center pr-3">
                                    <div className='w-16 pr-1 h-full flex flex-col items-end'>
                                        <p className='h-1/2'>Since:</p>
                                        <p className='h-1/2'>Exp:</p>
                                    </div>
                                    <div className='flex-1 h-full'>
                                        <p className='h-1/2 w-full'>{moment.unix(user.registeredDate / 1000).format('MM/DD/YYYY')}</p>
                                        <p className='h-1/2 w-full'></p>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full pr-3 flex flex-col items-end'>
                                <p>{`${user.firstName} ${user.lastName}`}</p>
                                {user.connectedInstagramHandle && <p>{`@${user.connectedInstagramHandle}`}</p>}
                                {user.membership && <p>Membership: {membershipNames[user.membership]}</p>}
                            </div>
                        </div>
                        <div className="w-full">
                            <Link
                                to="/account/edit-profile"
                                className={`${buttonClassName} sm:mt-10`}
                            >
                                <div className="w-24 flex items-center justify-center">
                                    <img src={EditProfile} className={iconClassName} alt="EditProfile" />
                                </div>
                                <span>Edit profile</span>
                            </Link>
                            <div
                                className={`${buttonClassName}`}
                                onClick={() => {
                                    setShowFeatureComingSoonPopup(true);
                                    setTimeout(() => {
                                        setShowFeatureComingSoonPopup(false)
                                    }, 2500)
                                }}
                            >
                                <div className="w-24 flex items-center justify-center">
                                    <img src={MemberServices} className={iconClassName} alt="MemberServices" />
                                </div>
                                <span>Member services</span>
                            </div>
                            <div
                                className={`${buttonClassName}`}
                                onClick={() => {
                                    setShowFeatureComingSoonPopup(true);
                                    setTimeout(() => {
                                        setShowFeatureComingSoonPopup(false)
                                    }, 2500)
                                }}
                            >
                                <div className="w-24 flex items-center justify-center">
                                    <img src={Preferences} className={iconClassName} alt="Preferances" />
                                </div>
                                <span>Preferences</span>
                            </div>
                            <Link
                                to="/settings"
                                className={buttonClassName}
                            >
                                <div className="w-24 flex items-center justify-center">
                                    <img src={settings} className={iconClassName} alt="settings" />
                                </div>
                                <span>Settings</span>
                            </Link>
                            <Modal isOpenModal={showFeatureComingSoonPopup} light={true}>
                                    This functionality will be available soon
                            </Modal>
                        </div>
                    </div>
                )
            }}
        </WithUserData>
    );
}
export default Account;